module.exports = __webpack_public_path__ + "static/media/01.0d58913a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/01.jpg
// module id = 370
// module chunks = 0